import { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { useUtmTaxonomyStore } from '@/store/utm-taxonomy-store';
import UtmImpactList from '@/components/utm/admin/impacts/UtmImpactList';
import UtmImpactForm from '@/components/utm/admin/impacts/UtmImpactForm';

const UtmImpactsPage = () => {
  const { fetchImpacts, fetchTaxonomy } = useUtmTaxonomyStore();

  useEffect(() => {
    fetchTaxonomy();
    fetchImpacts();
  }, [fetchTaxonomy, fetchImpacts]);

  return (
    <Routes>
      <Route index element={<UtmImpactList />} />
      <Route path="new" element={<UtmImpactForm />} />
      <Route path=":id/edit" element={<UtmImpactForm />} />
    </Routes>
  );
};

export default UtmImpactsPage;
